// extracted by mini-css-extract-plugin
export default {"main":"TopHeader_main__kjwJt","discount":"TopHeader_discount__h39Q6","shopNow":"TopHeader_shopNow__5CVOz","language":"TopHeader_language__GDFY5","select":"TopHeader_select__w9dpQ"};